export class SessionCheck {
  constructor() {
    const convertTimeToMinutes = (time) => {
      const [hours, minutes] = time.split(':').map(Number)
      return hours * 60 + minutes
    }

    const previousCheckTime = (target, elm, endTime, targetStartTime, check) => {
      if (!elm.classList.contains('is-sold')) {
        if (endTime > targetStartTime) {
          elm.classList.remove('is-disabled')
          elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
        }
      }

      if (target.classList.contains('is-cancel')) {
        if (endTime > targetStartTime) {
          elm.classList.add('is-disabled')
          elm.classList.remove('is-act')
          check.checked = false
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      let reservationText = ''
      let cancelText = ''

      const trgs = document.querySelectorAll('.js-reserve_trg')
      const checkSession = sessionStorage.getItem('checkSession')
      const checkSessionArray = checkSession ? checkSession.split(',') : []

      const formLang = document.querySelector('.js-form')
      if (!formLang) return
      if (formLang.classList.contains('js-form_en')) {
        reservationText = 'Select'
        cancelText = 'Cancel'
      } else {
        reservationText = '予約する'
        cancelText = 'キャンセル'
      }

      trgs.forEach((data) => {
        data.addEventListener('change', (e) => {
          const target = e.currentTarget

          const label = target.querySelector('.js-reserve_text')
          const targetBlock = target.closest('.js-session_block')
          const targetCard = target.closest('.js-session_card')
          const time = targetCard.querySelector('.js-session_time')
          const targetStartTime = convertTimeToMinutes(time.textContent.split('-')[0].trim())
          const targetEndTime = convertTimeToMinutes(time.textContent.split('-')[1].trim())

          const check = target.querySelector('.js-checkbox_input')
          const checkNum = check.id
          if (check.checked) {
            if (!checkSessionArray.includes(checkNum)) {
              checkSessionArray.push(checkNum)
            }
          } else {
            const index = checkSessionArray.indexOf(checkNum)
            if (index > -1) {
              checkSessionArray.splice(index, 1)
            }
          }

          sessionStorage.setItem('checkSession', checkSessionArray)

          target.classList.toggle('is-cancel')
          targetCard.classList.toggle('is-act')
          if (target.classList.contains('is-cancel')) {
            if (label) {
              label.textContent = cancelText
            }
          } else {
            if (label) {
              label.textContent = reservationText
            }
          }
          const cards = targetBlock.querySelectorAll('.js-session_card')
          cards.forEach((elm) => {
            elm.classList.remove('is-disabled')
            if (!elm.classList.contains('is-act') || elm.classList.contains('is-sold')) {
              elm.classList.add('is-disabled')
            }
          })

          if (label) {
            if (label.textContent === reservationText) {
              cards.forEach((elm) => {
                if (!elm.classList.contains('is-sold')) {
                  elm.classList.remove('is-disabled')
                }
              })
            }
          }

          //前のブロックも確認
          const previousBlock = targetBlock.previousElementSibling
          if (!previousBlock) return
          let previousFlg = false
          const previousCards = previousBlock.querySelectorAll('.js-session_card')
          previousCards.forEach((elm) => {
            const time = elm.querySelector('.js-session_time')
            const endTime = convertTimeToMinutes(time.textContent.split('-')[1].trim())
            const check = elm.querySelector('.js-checkbox_input')
            if (elm.classList.contains('is-act')) {
              previousFlg = true
              if (endTime > targetStartTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }
            if (!elm.classList.contains('is-sold')) {
              if (endTime > targetStartTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }

            if (target.classList.contains('is-cancel')) {
              if (endTime > targetStartTime) {
                elm.classList.add('is-disabled')
                elm.classList.remove('is-act')
                check.checked = false
              }
            } else {
              if (previousFlg && endTime > targetStartTime) {
                elm.classList.add('is-disabled')
                elm.classList.remove('is-act')
                check.checked = false
              }
            }
          })

          //次のブロックも確認
          const nextBlock = targetBlock.nextElementSibling
          if (!nextBlock) return
          let nextFlg = false
          const nextCards = nextBlock.querySelectorAll('.js-session_card')
          nextCards.forEach((elm) => {
            const time = elm.querySelector('.js-session_time')
            const startTime = convertTimeToMinutes(time.textContent.split('-')[0].trim())
            const check = elm.querySelector('.js-checkbox_input')

            if (elm.classList.contains('is-act')) {
              nextFlg = true
              if (startTime < targetEndTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }
            if (!elm.classList.contains('is-sold')) {
              if (startTime < targetEndTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }

            if (target.classList.contains('is-cancel')) {
              if (startTime < targetEndTime) {
                elm.classList.add('is-disabled')
                elm.classList.remove('is-act')
                check.checked = false
              }
            } else {
              if (nextFlg && startTime < targetEndTime) {
                elm.classList.add('is-disabled')
                elm.classList.remove('is-act')
                check.checked = false
              }
            }
          })
        })
      })

      // リロード時の処理
      const blocks = document.querySelectorAll('.js-session_block')
      blocks.forEach((element) => {
        let targetStartTime = ''
        let targetEndTime = ''
        let targetBlock = ''
        const cards = element.querySelectorAll('.js-session_card')
        cards.forEach((elm) => {
          const check = elm.querySelector('.js-checkbox_input')
          if (check) {
            const checkNum = check.id
            if (checkSessionArray.includes(checkNum)) {
              check.parentNode.classList.add('is-cancel')
              elm.closest('.js-session_card').classList.add('is-act')
              check.checked = true
              targetStartTime = convertTimeToMinutes(elm.querySelector('.js-session_time').textContent.split('-')[0].trim())
              targetEndTime = convertTimeToMinutes(elm.querySelector('.js-session_time').textContent.split('-')[1].trim())
              targetBlock = elm.closest('.js-session_block')
              const lists = elm.closest('.c-session_list')
              lists.querySelectorAll('.js-session_card').forEach((card) => {
                if (!card.classList.contains('is-act')) {
                  card.classList.add('is-disabled')
                }
              })
            }
          }
        })

        setTimeout(() => {
          const previousBlock = targetBlock.previousElementSibling
          if (!previousBlock) return

          const previousCards = previousBlock.querySelectorAll('.js-session_card')
          previousCards.forEach((elm) => {
            const time = elm.querySelector('.js-session_time')
            const endTime = convertTimeToMinutes(time.textContent.split('-')[1].trim())
            const check = elm.querySelector('.js-checkbox_input')
            if (!elm.classList.contains('is-sold')) {
              if (endTime > targetStartTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }
            if (endTime > targetStartTime) {
              elm.classList.add('is-disabled')
              elm.classList.remove('is-act')
              check.checked = false
            }
          })

          const nextBlock = targetBlock.nextElementSibling
          if (!nextBlock) return

          const nextCards = nextBlock.querySelectorAll('.js-session_card')
          nextCards.forEach((elm) => {
            const time = elm.querySelector('.js-session_time')
            const startTime = convertTimeToMinutes(time.textContent.split('-')[0].trim())
            const check = elm.querySelector('.js-checkbox_input')

            if (!elm.classList.contains('is-sold')) {
              if (startTime < targetEndTime) {
                elm.classList.remove('is-disabled')
                elm.querySelector('.js-reserve_trg').classList.remove('is-cancel')
              }
            }

            if (startTime < targetEndTime) {
              elm.classList.add('is-disabled')
              elm.classList.remove('is-act')
              check.checked = false
            }
          })
        }, 100)
      })
    })
  }
}
